import {Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {Subscription} from 'rxjs';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {HelperService} from "../../service/helper.service";
import {TranslateConfigService} from "../../service/translate-config.service";

@Component({
  selector: 'app-lsp-xd',
  templateUrl: './lsp.component.html',
  styleUrls: ['./lsp.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LspXocDiaComponent implements OnInit, OnDestroy {

  @ViewChild('lspXD', {static: false}) elLspXD: ElementRef;

  subscriptionLSP: Subscription;
  subscriptionScreenOri: Subscription;

  hisPhienRateTotalCount = 20;
  listHisPhien = [];
  percentChan = 0;
  percentLe = 0;
  percentHoa = 0;

  getResultLatest: any = [];

  constructor(
    private modalCtr: ModalController,
    private hpService: HelperService,
    private screenOrientation: ScreenOrientation,
    public platform: Platform,
    public translateConfigService: TranslateConfigService
  ) {
    this.subscriptionLSP = this.hpService.getObserverHisPhienXD().subscribe(wsData => {
      this.listHisPhien = wsData.slice(0, this.hisPhienRateTotalCount);
      this.getResultPercent();
      this.formatHisPhien(this.listHisPhien).then((list) => {
        if (list && list.length > 0) {
          this.getResultLatest = list;
        }
      });
    });

    platform.ready().then((readySource) => {
      this.detectScreenOrient();
    });
    this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
      () => {
        this.detectScreenOrient();
      }
    );
  }

  detectScreenOrient() {
    setTimeout(() => {
      const pH = this.platform.height();
      const hGame = 325;
      if (pH < hGame) {
        this.elLspXD.nativeElement.style.transform = `scale(${(pH / hGame)})`;
      } else {
        this.elLspXD.nativeElement.style.transform = `scale(1)`;
      }
    }, 100);
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.subscriptionLSP.unsubscribe();
    this.subscriptionScreenOri.unsubscribe();
  }

  ionViewWillEnter() {
  }

  async formatHisPhien(list) {
    if (list.length <= 0) {
      return;
    } else {
      list = list.reverse();
    }
    list.map(item => {
      const total = item.result[0] + item.result[1] + item.result[2] + item.result[3];
      if (total == 4 || total == 0) {
        item.type = this.translateConfigService.getTranslateService().instant('MINI-GAME.chan-short');
      } else if (total == 3 || total == 1) {
        item.type = this.translateConfigService.getTranslateService().instant('MINI-GAME.le-short');
      } else {
        item.type = this.translateConfigService.getTranslateService().instant('MINI-GAME.hoa-short');
      }
      return item;
    });
    return await list;
  }

  radioHistoryPhien(event, count) {
    event.preventDefault();
    this.hisPhienRateTotalCount = count;
    this.getResultPercent();
  }

  getResultPercent() {
    const totalLength = this.hisPhienRateTotalCount;
    const list = this.listHisPhien.slice(0, totalLength);
    const countChan = list.filter(item => this.countTotalRs(item) === 4 || this.countTotalRs(item) === 0).length;
    const countLe = list.filter(item => this.countTotalRs(item) === 3 || this.countTotalRs(item) === 1).length;
    this.percentChan = Math.floor(countChan / totalLength * 100);
    this.percentLe = Math.floor(countLe / totalLength * 100);
    this.percentHoa = 100 - this.percentChan - this.percentLe;
  }

  countTotalRs(item) {
    if (item.result && item.result.length === 4) {
      return Number(item.result[0] + item.result[1] + item.result[2] + item.result[3]);
    }
    return -1;
  }

  async closeModal() {
    await this.modalCtr.dismiss();
  }


}
